<template>
  <div class="lower">
    <!-- ==================== [[ PCJ Tag ]] ==================== -->
    <div is="script" type="text/javascript">
      function kpp_tracking_event(category, event, site, abtesting, iscta,
      newgtm) { if (event && category) { if (newgtm) { dataLayer.push({'event':
      'uaevent','eventCategory': category,'eventAction': site,'eventLabel':
      event}); } else { } } }
    </div>

    <!-- NBA_dataLayer_v1 -->
    <div is="script">
      var pageName; var _ua = (function(u){ return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 &&
      u.indexOf("tablet pc") == -1) || u.indexOf("ipad") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
      (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
      u.indexOf("kindle") != -1 || u.indexOf("silk") != -1 ||
      u.indexOf("playbook") != -1, Mobile:(u.indexOf("windows") != -1 &&
      u.indexOf("phone") != -1) || u.indexOf("iphone") != -1 ||
      u.indexOf("ipod") != -1 || (u.indexOf("android") != -1 &&
      u.indexOf("mobile") != -1) || (u.indexOf("firefox") != -1 &&
      u.indexOf("mobile") != -1) || u.indexOf("blackberry") != -1 }
      })(window.navigator.userAgent.toLowerCase()); if(_ua.Mobile ||
      _ua.Tablet){ pageName = 'access/promotion::YOUR-STORIES/local/B2C/new
      cars//mobile/1CB6A5|1CW8AF|1CH5CL|1CCESY/YOUR-STORIES'; }else{ pageName =
      'access/promotion::YOUR-STORIES/local/B2C/new
      cars//desktop/1CB6A5|1CW8AF|1CH5CL|1CCESY/YOUR-STORIES'; } var dataLayer =
      [{ 'brand':'citroen', 'virtualPageURL':'/cpn/your-stories/story/',
      'pageName':pageName, 'siteTypeLevel1':'access',
      'siteTypeLevel2':'promotion::YOUR-STORIES', 'siteOwner':'local',
      'siteTarget':'B2C', 'siteFamily':'new cars', 'language':'ja',
      'country':'jp', 'pageCategory':'home page',
      'vehicleModelBodystyle':'1CB6A5|1CW8AF|1CH5CL|1CCESY',
      'vehicleModelBodystyleLabel':'C3|C3 AIRCROSS SUV|GRAND C4 SPACETOURER|C5
      AIRCROSS SUV', }];
    </div>
    <!-- enf of NBA_dataLayer_v1 -->

    <!-- Google Tag Manager PSA_GTM_v2 -->
    <div is="noscript">
      <iframe
        src="//www.googletagmanager.com/ns.html?id=GTM-T8GRQS"
        height="0"
        width="0"
        style="display: none; visibility: hidden;"
      ></iframe>
    </div>
    <div is="script" type="text/javascript" v-html="gtm"></div>
    <!-- End Google Tag Manager PSA_GTM_v2 -->

    <!-- ==================== /[[ PCJ Tag ]] ==================== -->
    <div class="lower__wrap">
      <div class="lower__inner">
        <div class="lower__logo">
          <router-link to="/" target="_blank">
            <picture>
              <source
                type="image/webp"
                srcset="
                  ../assets/images-webp/lp-logo.webp    1x,
                  ../assets/images-webp/lp-logo@2x.webp 2x
                "
              />
              <img
                src="../assets/images/lp-logo.png"
                srcset="
                  ../assets/images/lp-logo.png    1x,
                  ../assets/images/lp-logo@2x.png 2x
                "
                alt="Your Stories with CITROEN"
              />
            </picture>
          </router-link>
        </div>
        <div class="lower__col__wrap">
          <div class="lower__col__right">
            <div class="lower__textbox">
              <p class="lower__text" v-html="routeData.text"></p>
            </div>
            <span class="lower__writer">@{{ routeData.writer }}</span>
          </div>
          <div class="lower__col__left">
            <picture>
              <source
                type="image/webp"
                v-bind:srcset="routeData.webpSrcsetPath"
              />
              <source v-bind:srcset="routeData.imgSrcsetPath" />
              <img
                v-bind:src="routeData.imgPath"
                v-bind:srcset="routeData.imgSrcsetPath"
                alt=""
              />
            </picture>
          </div>
        </div>
        <div class="lower__arrow--next" v-on:click="goNextPage">
          <svg viewBox="0 0 41 37.063">
            <path
              d="M1234.66,450.421a57.876,57.876,0,0,1-12.67,13.2l4.34,5.46a68.977,68.977,0,0,0,16.45-17.737,1.727,1.727,0,0,0,.23-0.919,2.078,2.078,0,0,0-.23-0.909A70.391,70.391,0,0,0,1226.57,432l-4.47,5.578A57.485,57.485,0,0,1,1234.66,450.421Z"
              transform="translate(-1222 -432)"
            />
            <path
              d="M1254.66,450.421a57.876,57.876,0,0,1-12.67,13.2l4.34,5.46a68.977,68.977,0,0,0,16.45-17.737,1.727,1.727,0,0,0,.23-0.919,2.078,2.078,0,0,0-.23-0.909A70.391,70.391,0,0,0,1246.57,432l-4.47,5.578A57.485,57.485,0,0,1,1254.66,450.421Z"
              transform="translate(-1222 -432)"
            />
          </svg>
        </div>
        <div class="lower__arrow--prev" v-on:click="goPrevPage">
          <svg viewBox="0 0 41 37">
            <path
              d="M130.335,450.61a58.036,58.036,0,0,1,12.678-13.174l-4.339-5.451a68.785,68.785,0,0,0-16.45,17.708,1.713,1.713,0,0,0-.231.917,2.05,2.05,0,0,0,.231.907A70.159,70.159,0,0,0,138.435,469l4.463-5.569A57.727,57.727,0,0,1,130.335,450.61Z"
              transform="translate(-102 -432)"
            />
            <path
              d="M110.335,450.61a58.036,58.036,0,0,1,12.678-13.174l-4.339-5.451a68.785,68.785,0,0,0-16.45,17.708,1.713,1.713,0,0,0-.231.917,2.05,2.05,0,0,0,.231.907A70.159,70.159,0,0,0,118.435,469l4.463-5.569A57.727,57.727,0,0,1,110.335,450.61Z"
              transform="translate(-102 -432)"
            />
          </svg>
        </div>
      </div>
      <div class="lower__sns-link">
        <div class="lower__sns-link__label">
          <span class="lower__sns-link__label__item">シェアする</span>
        </div>
        <social-sharing
          v-bind:url="routeData.url"
          description=""
          :hashtags="`citroen,` + routeData.car"
          inline-template
        >
          <div class="lower__sns-link__inner">
            <network
              network="twitter"
              class="lower__sns-link__item--tw"
            ></network>
            <network
              network="facebook"
              class="lower__sns-link__item--fb"
            ></network>
          </div>
        </social-sharing>
      </div>
    </div>
    <div class="lower__close">
      <span class="lower__close__item" v-on:click="closeWindow">閉じる</span>
    </div>
    <div class="lower__toTop">
      <router-link to="/" class="lower__toTop__item" target="_blank"
        >Your Stories with CITROEN TOPへ</router-link
      >
    </div>
    <note-section></note-section>
  </div>
</template>
<script>
import NoteSection from "../components/NoteSection";
export default {
  name: "lower-page-template",
  components: {
    NoteSection,
  },
  data: function () {
    return {
      routeData: {
        url: "",
        title: "",
        text: "",
        writer: "",
        car: "",
        imgPath: "",
        imgSrcsetPath: "",
        webpSrcsetPath: "",
      },
      gtm:
        "/*<![CDATA[*/(function(w,d,s,l,i){w[l]=w[l]||[]; w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'}); var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:''; j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-T8GRQS'); /*]]>*/",
    };
  },
  watch: {
    $route: function () {
      this.getRoutesData();
    },
  },
  methods: {
    closeWindow: function () {
      window.close();
    },
    goNextPage: function () {
      var current = this.$route.matched[0].props.default.title;
      var nextNumber = Number(current.replace("story", ""));
      var nextPage;
      nextNumber++;
      if (nextNumber < this.$router.options.routes.length - 1) {
        if (nextNumber < 10) {
          nextNumber = "00" + nextNumber;
        } else if (nextNumber >= 10) {
          nextNumber = "0" + nextNumber;
        }
        nextPage = "/story" + nextNumber + "/";
      } else {
        nextPage = "/story001/";
      }
      this.$router.push({ path: nextPage });
    },
    goPrevPage: function () {
      var current = this.$route.matched[0].props.default.title;
      var prevNumber = Number(current.replace("story", ""));
      var prevPage;
      prevNumber--;
      if (prevNumber > 0) {
        if (prevNumber < 10) {
          prevNumber = "00" + prevNumber;
        } else if (prevNumber >= 10) {
          prevNumber = "0" + prevNumber;
        }
        prevPage = "/story" + prevNumber + "/";
      } else {
        var length = this.$router.options.routes.length - 2;
        if (length < 100) {
          length = "0" + length;
        }
        prevPage = "/story" + length + "/";
      }
      this.$router.push({ path: prevPage });
    },
    getRoutesData: function () {
      this.routeData.url =
        "https://web.citroen.jp/cpn/your-stories" + this.$route.fullPath;
      this.routeData.title = this.$route.matched[0].props.default.title;
      this.routeData.text = this.$route.matched[0].props.default.text;
      this.routeData.writer = this.$route.matched[0].props.default.writer;
      this.routeData.car = this.$route.matched[0].props.default.car;
      this.routeData.imgPath = require("../assets/picture/" +
        this.routeData.title +
        ".png");
      this.routeData.imgSrcsetPath =
        require("../assets/picture/" + this.routeData.title + ".png") +
        " 1x, " +
        require("../assets/picture/" + this.routeData.title + "@2x.png") +
        " 2x";
      this.routeData.webpSrcsetPath =
        require("../assets/picture-webp/" + this.routeData.title + ".webp") +
        " 1x, " +
        require("../assets/picture-webp/" + this.routeData.title + "@2x.webp") +
        " 2x";
    },
    kpp_tracking_event: function (
      category,
      event,
      site,
      abtesting,
      iscta,
      newgtm
    ) {
      console.log("tracking!");
      if (event && category) {
        if (newgtm) {
          this.dataLayer.push({
            event: "uaevent",
            eventCategory: category,
            eventAction: site,
            eventLabel: event,
          });
        }
      }
    },
  },
  created: function () {
    this.getRoutesData();
  },
  mounted: function () {
    // var pageName;
    // var _ua = (function (u) {
    //   return {
    //     Tablet:
    //       (u.indexOf("windows") != -1 &&
    //         u.indexOf("touch") != -1 &&
    //         u.indexOf("tablet pc") == -1) ||
    //       u.indexOf("ipad") != -1 ||
    //       (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
    //       (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
    //       u.indexOf("kindle") != -1 ||
    //       u.indexOf("silk") != -1 ||
    //       u.indexOf("playbook") != -1,
    //     Mobile:
    //       (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
    //       u.indexOf("iphone") != -1 ||
    //       u.indexOf("ipod") != -1 ||
    //       (u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
    //       (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) ||
    //       u.indexOf("blackberry") != -1,
    //   };
    // })(window.navigator.userAgent.toLowerCase());
    // if (_ua.Mobile || _ua.Tablet) {
    //   //mobile or tablet
    //   pageName =
    //     "access/promotion::YOUR-STORIES/local/B2C/new cars//mobile/1CB6A5|1CW8AF|1CH5CL|1CCESY/YOUR-STORIES";
    // } else {
    //   pageName =
    //     "access/promotion::YOUR-STORIES/local/B2C/new cars//desktop/1CB6A5|1CW8AF|1CH5CL|1CCESY/YOUR-STORIES";
    // }
    // this.dataLayer = [
    //   {
    //     // beginning of variable + value
    //     // Common to all pages
    //     brand: "citroen",
    //     virtualPageURL: "/cpn/your-stories/story/",
    //     pageName: pageName,
    //     siteTypeLevel1: "access",
    //     siteTypeLevel2: "promotion::YOUR-STORIES",
    //     siteOwner: "local",
    //     siteTarget: "B2C",
    //     siteFamily: "new cars",
    //     language: "ja",
    //     country: "jp",
    //     pageCategory: "home page",
    //     vehicleModelBodystyle: "1CB6A5|1CW8AF|1CH5CL|1CCESY",
    //     vehicleModelBodystyleLabel:
    //       "C3|C3 AIRCROSS SUV|GRAND C4 SPACETOURER|C5 AIRCROSS SUV",
    //     // end of variable + value
    //   },
    // ];
    // var vm = this;
    // var snsTW = document.getElementsByClassName("lower__sns-link__item--tw")[0];
    // var snsFB = document.getElementsByClassName("lower__sns-link__item--fb")[0];
    // snsTW.addEventListener("click", function () {
    //   vm.kpp_tracking_event(
    //     "Content",
    //     "facebook",
    //     "Redirection::External",
    //     false,
    //     false,
    //     "newgtm"
    //   );
    // });
    // snsFB.addEventListener("click", function () {
    //   vm.kpp_tracking_event(
    //     "Content",
    //     "twitter",
    //     "Redirection::External",
    //     false,
    //     false,
    //     "newgtm"
    //   );
    // });
  },
};
</script>
<style lang="scss">
@import "../assets/css/mixins";
.lower {
  iframe {
    position: absolute;
  }
  &__wrap {
    background-color: #dddbd6;
    margin-left: -15px;
    margin-right: -15px;
    padding: 135px 11.22448979591837% 60px;
    @include mq-down {
      padding: 100px 15px 30px;
    }
  }
  &__inner {
    max-width: 980px;
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 35px 55px;
    position: relative;
    @include mq-down {
      padding: 20px 30px;
    }
    &::before {
      content: "";
      display: block;
      width: calc(100% - 20px);
      height: 21px;
      position: absolute;
      top: -19px;
      right: 0;
      left: 0;
      margin: auto;
      background-image: url(../assets/images/voice-bg_white.png);
    }
  }
  &__logo {
    max-width: 568px;
    width: 70%;
    margin: 10px auto 35px;
  }
  &__col {
    &__wrap {
      overflow: hidden;
    }
    &__left {
      float: left;
      width: 37.70114942528736%;
      @include mq-down {
        width: 100%;
      }
    }
    &__right {
      float: right;
      width: 59.19540229885057%;
      @include mq-down {
        width: 100%;
        margin-bottom: 30px;
      }
    }
  }
  &__textbox {
    display: block;
    margin-top: 25px;
  }
  &__text {
  }
  &__writer {
    text-align: right;
    display: block;
    margin-top: 50px;
  }
  &__sns-link {
    &__inner {
      text-align: center;
    }
    &__label {
      text-align: center;
      margin-top: 50px;
      margin-bottom: 15px;
      &__item {
        padding: 0 10px;
        color: #5c5c5c;
        position: relative;
        line-height: 1;
        &::before {
          content: "";
          display: block;
          width: 1px;
          height: 80%;
          background-color: #5c5c5c;
          position: absolute;
          bottom: 5px;
          left: 0;
          transform-origin: bottom;
          transform: rotate(-35deg);
        }
        &::after {
          @extend .lower__sns-link__label__item::before;
          left: inherit;
          right: 0;
          transform: rotate(35deg);
        }
      }
    }
    &__item {
      display: inline-block;
      width: 44px;
      height: 44px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      cursor: pointer;
      & + & {
        margin-left: 20px;
      }
      &--tw {
        @extend .lower__sns-link__item;
        background-image: url(../assets/images/icon-twitter.svg);
      }
      &--fb {
        @extend .lower__sns-link__item;
        background-image: url(../assets/images/icon-facebook.svg);
      }
    }
  }
  &__arrow {
    width: 43px;
    height: 39px;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    fill: #fff;
    @include mq-down {
      top: -70px;
      bottom: inherit;
    }
    &--prev {
      @extend .lower__arrow;
      left: -8.979591836734694%;
      @include mq-down {
        left: 0px;
      }
    }
    &--next {
      @extend .lower__arrow;
      right: -8.979591836734694%;
      @include mq-down {
        right: 0px;
      }
    }
  }
  &__close {
    text-align: center;
    padding: 31px 0;
    border-bottom: 1px solid #d7d7d7;
    &__item {
      font-size: 22px;
      cursor: pointer;
    }
  }
  &__toTop {
    @extend .lower__close;
    &__item {
      @extend .lower__close__item;
    }
  }
}
</style>
